import { observable } from "mobx"

import { Locations } from "~/api/student/profile/_get-types/InternshipExperience"

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type InternshipInterest = {
  major_occupations: {
    id: number
    name: string
  }[]
}

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type InternshipMotivation = {
  frequency?: number | null
  frequency_weekday?: number | null
  available_hours_per_week?: number | null
  period?: number | null
}
interface internshipExperienceArgs {
  interest: InternshipInterest
  internship_motivations: InternshipMotivation
  locations: Locations
}

export class InternshipExperience {
  @observable interest: InternshipInterest
  @observable internship_motivations: InternshipMotivation
  @observable locations: Locations

  constructor(args: internshipExperienceArgs) {
    this.interest = args.interest
    this.internship_motivations = args.internship_motivations || {
      frequency: null,
      frequency_weekday: null,
      available_hours_per_week: null,
      period: null,
    }
    this.locations = args.locations || {
      home_station: null,
      school_station: null,
      desired_work_areas: [],
    }
  }
}
